import { Component, Input } from '@angular/core';

import { CaArea, CaGroup } from '../../../core';
import { setFocusPhrase } from '../../function/set-focus-phrase.function';

@Component({
    selector: 'cmps-ca-evaluation-phrase',
    templateUrl: './phrase.component.html',
})
export class PhraseComponent {
    @Input()
    group: CaGroup;

    @Input()
    area: CaArea;

    /** @private */
    _onDeleteClick(): void {
        setFocusPhrase(this.area, null);
    }
}
